import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const payrollListService = (params: Types.PayrollListRequest) =>
  RestAPIClient.call<Types.PayrollListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const viewPayslipService = (params: Types.ViewPayslipRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.GET,
    url: Paths.ViewPayslip,
    config: {
      requireAuthentication: true,
      params: {
        ...params,
      },
    },
  });

export const payrollBankTransferExportService = (
  params: Types.PayrollBankTransferExportRequest
) =>
  RestAPIClient.call<Types.PayrollBankTransferExportResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.BankTransfer,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const payrollSendPayslipService = (params: Types.SendPayslipRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.SendPayslip,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const payrollPayslipLogCreateService = (
  params: Types.CreatePayslipLogRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.PayslipLog,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const payrollPayslipLogListService = (
  params: Types.PayrollPayslipLogListRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.GET,
    url: Paths.PayslipLog,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const payrollApprovalStatusService = (
  params: Types.PayrollApprovalStatusListRequest
) =>
  RestAPIClient.call<Types.PayrollApprovalStatusItem>({
    method: HTTPRequestMethods.GET,
    url: Paths.ApprovalStatus,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const payrollTemplatePayslipListService = (params: {
  page?: number;
  limit?: number;
  ids?: string[];
  status?: number;
  type?: string;
  code?: string;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.TemplatePayslip>>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListTemplatePayslip,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const checkPayslipReadinessService = (
  params: Types.CheckPayslipReadinessRequest
) =>
  RestAPIClient.call<Types.CheckPayslipReadinessResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.CheckPayslipReadiness,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const generatePayslipFileService = (
  params: Types.GeneratePayslipFileRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.GeneratePayslipFile,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
